<div class="popup">
  <div class="container-detalles panelDetailGProcess" [ngClass]="{'expandir': fullScreen}">
    <loading [isLoading]="geoClustersFrecuencyCatalogService.isLoading"></loading>

    <div *ngIf="!mobileQuery.matches" class="btnClose">
      <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false" aria-label="Example home icon" fontIcon="cancel" (click)="Close()"></mat-icon>
    </div>

    <div *ngIf="!mobileQuery.matches" class="arrow-container">
        <mat-icon *ngIf="!fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_up</mat-icon>
        <mat-icon *ngIf="fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_down</mat-icon>
    </div>
    <div class="details-flex">

      <!-- Primera sección -->
      <div class="header_panel">

          <!-- Botón regresar-->
          <a class="btnReturn" (click)="Close()" matTooltip="Regresar"><mat-icon>arrow_back_ios</mat-icon></a>

          <!-- Encabezado -->
          <div class="header-background" [ngClass]="{'col-3': !mobileQuery.matches}">
            <img [src]="'carA.png' | findUrl" class="header-img" />
          </div>

          <!-- VIN-->
          <div class="row header-text" [ngClass]="{'col-9': !mobileQuery.matches}">
            <label *ngIf="!mobileQuery.matches" class="header-text-label">Id</label>
            <label class="titlePanel vin-title"> {{ this.identifier }}</label>

            <label *ngIf="!mobileQuery.matches" class="header-text-label">Descripción</label>
            <label class="subtitlePanel"> Geoproceso de análisis espacial de lugares recurrentes</label>
          </div>

      </div>
      <!-- seccion de tabs -->
      <div class="tab-group">
        <mat-tab-group>
          <mat-tab>
            <ng-template matTabContent >
              <div class="tab-content-wrapper">
                <!-- Primera sección grafico de todos-->
                <div [ngClass]="{'container': mobileQuery.matches}">
                  <div class="row text-header">
                    <div class="section-header-background">
                      <h3>Probabilidad de lugares</h3>
                    </div>
                  </div>

                  <div class="row text-instructions">
                    <p>Selecciona una sección en el gráfico para ver los detalles.</p>
                  </div>
  
                  <div style="display: block; width: 100%;">
                    <canvas *ngIf="pieChartData?.datasets?.[0]?.data?.length"
                            baseChart
                            [data]="pieChartData"
                            [type]="pieChartType"
                            [labels]="pieChartLabels"
                            [legend]="true"
                            [options]="pieChartOptions"
                            (chartClick)="onPieChartClick($event)"
                            style="height: 300px; width: 100%;">
                    </canvas>
                  </div>
  
                </div>
              </div>

            </ng-template>
          </mat-tab>
          
        </mat-tab-group>
      </div>
    </div>  

  </div>
</div>